import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LiveMessageContext from './LiveMessageContext';
import LiveMessageBlock from './LiveMessageBlock';
import LiveAnnounce from './LiveAnnounce';

const LiveAnnounceProvider = ({ children }) => {
  const [announcePoliteMessage, setAnnouncePoliteMessage] = useState('');
  const [announceAssertiveMessage, setAnnounceAssertiveMessage] = useState('');

  const announcePolite = (message) => {
    setAnnouncePoliteMessage(message);
  };

  const announceAssertive = (message) => {
    setAnnounceAssertiveMessage(message);
  };

  return (
    <LiveMessageContext.Provider value={{ announcePolite, announceAssertive }}>
      {children}
      {announceAssertiveMessage && (
        <LiveMessageBlock
          aria-live="assertive"
          message={announceAssertiveMessage}
        />
      )}
      {announcePoliteMessage && (
        <LiveMessageBlock aria-live="polite" message={announcePoliteMessage} />
      )}
    </LiveMessageContext.Provider>
  );
};

LiveAnnounceProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { LiveAnnounceProvider, LiveAnnounce };
